import { useSelector } from "react-redux";
import HireDevelopers from "../common/HireDevelopers";
const EmoteEngineer = ({selected_skill}) => {
    return (
        <section className="bg-black text-white !pt-[60px] !pb-[50px] md:!pb-[100px]">
            <div className="--layout-padding max-width">
                <div className="emotEngieerCon">
                    <h3 className="text-[35px] font-semibold"><span className="text-primary-color"> {selected_skill}</span> is not the best fit?</h3>
                    <HireDevelopers />
                </div>
            </div>
        </section>

    );
};
export default EmoteEngineer;